<template>
  <div class="contracts-view">
    <h1 class="text-h4 mb-4">{{ t('contracts.title') }}</h1>

    <v-card class="mb-4">
      <v-card-title>{{ t('contracts.deployed') }}</v-card-title>
      <v-card-text>
        <v-table v-if="contracts.length > 0">
          <thead>
            <tr>
              <th>{{ t('accounts.address') }}</th>
              <th>{{ t('contracts.codeHash') }}</th>
              <th>{{ t('contracts.deployer') }}</th>
              <th>{{ t('contracts.size') }}</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in contracts" :key="c.address">
              <td><code>{{ c.address.slice(0, 16) }}...</code></td>
              <td><code>{{ c.code_hash }}</code></td>
              <td><code>{{ c.deployer.slice(0, 12) }}...</code></td>
              <td>{{ c.size }} bytes</td>
              <td>{{ new Date(c.deployed_at * 1000).toLocaleString() }}</td>
            </tr>
          </tbody>
        </v-table>
        <p v-else class="text-grey">{{ t('contracts.noContracts') }}</p>
      </v-card-text>
    </v-card>

    <v-card class="mb-4">
      <v-card-title>{{ t('contracts.call') }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="callAddress" label="Endereço do Contrato" variant="outlined" density="comfortable" />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="callFunction" :label="t('contracts.function')" variant="outlined" density="comfortable" placeholder="get_totalSupply" />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="callArgs" label="Argumentos (vírgula)" variant="outlined" density="comfortable" placeholder="0,1000" />
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="primary" block @click="chamarContrato" :loading="calling">{{ t('contracts.call') }}</v-btn>
          </v-col>
        </v-row>
        <v-alert v-if="callResult" :type="callResult.status === 'success' ? 'success' : 'error'" class="mt-3">
          <div>Status: {{ callResult.status }}</div>
          <div>Gas: {{ callResult.gas_used }}</div>
          <div v-if="callResult.result && callResult.result.length">Resultado: {{ callResult.result.join(', ') }}</div>
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ExplorerAPI } from '@/services/api'

const contracts = ref([])
const callAddress = ref('')
const callFunction = ref('')
const callArgs = ref('')
const callResult = ref(null)
const calling = ref(false)

onMounted(async () => {
  try {
    const data = await ExplorerAPI.contratos.listar()
    contracts.value = data.contracts || []
    if (contracts.value.length > 0) {
      callAddress.value = contracts.value[0].address
    }
  } catch (e) {
    console.error('Erro ao carregar contratos:', e)
  }
})

async function chamarContrato() {
  calling.value = true
  callResult.value = null
  try {
    const args = callArgs.value ? callArgs.value.split(',').map(Number) : []
    callResult.value = await ExplorerAPI.contratos.chamar(callAddress.value, callFunction.value, args)
  } catch (e) {
    callResult.value = { status: 'error', gas_used: 0, result: [e.message] }
  }
  calling.value = false
}
</script>
